import { render, staticRenderFns } from "./UniqueAccountsRegister.vue?vue&type=template&id=5645026e&scoped=true&"
import script from "./UniqueAccountsRegister.vue?vue&type=script&lang=js&"
export * from "./UniqueAccountsRegister.vue?vue&type=script&lang=js&"
import style0 from "./UniqueAccountsRegister.vue?vue&type=style&index=0&id=5645026e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5645026e",
  null
  
)

export default component.exports